import React from "react";
import { Edit as RaEdit } from "react-admin";
import { useHistory } from "react-router-dom";
import { useFormStyles } from "../components/forms/useStyles";
import Title from "../components/Title";
import Form from "./Form";

const Edit = (props) => {
	const classes = useFormStyles();
	const history = useHistory();
	const handleSuccess = (p) => {
		history.go(-1);
	};
	return (
		<RaEdit
			{...props}
			classes={classes}
			mutationMode="pessimistic"
			title={<Title source="hash" />}
			onSuccess={handleSuccess}
		>
			<Form edit />
		</RaEdit>
	);
};

export default Edit;
